// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/BAI_HorizontalLockup_Primary_CMYK.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* We're gonna be ripping out these pieces that are tied to bootstrap clases.
.row.header {
    margin-top: 15px;
}
*/
/* Replacing it with an id */
#header {
  margin-top: 15px;
}

#header .navbar-brand {
  height: inherit;
  padding: 0px;
}

/* Ensure we don't override the logo from custom css, as style below is more specific. */
#logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: left center;
  background-repeat: no-repeat;
}

#BAIOnlylogo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: left center;
  background-repeat: no-repeat;
  min-height: 88px;
  margin: 0px 0px 15px;
  padding: 0px;
  text-indent: -99999px;
  background-size: contain;
  min-width: 75%;
  float: left;
}

#header #logo {
  min-height: 88px;
  margin: 0px 0px 15px;
  padding: 0px;
  text-indent: -99999px;
  text-indent: -99999px;
  background-size: contain;
  min-width: 75%;
  float: left;
}

.row.header > .col-md-3 .logout {
  text-align: right;
  position: relative;
}

.row.header > .col-md-3 .logout a {
  cursor: pointer;
  font-size: 12px;
}

.row.header > .col-md-12 .secondaryNav {
  list-style: none;
  margin: 0 auto 15px;
  overflow: hidden;
  padding: 0px;
  /* width: 50%; */
  display: flex;
}

.row.header > .col-md-12 .secondaryNav li {
  display: inline;
  float: right;
  text-align: center;
  width: 33%;
}

/* Search box */
#search {
  background-color: white !important;
  border: gray 1px solid;
  color: black;
  border-radius: initial;
  align-self: center;
}

form.searchForm {
  margin-right: -7px;
  padding-right: 0;
  padding-top: 5px;
}

#search::-webkit-input-placeholder {
  color: #a0a0a0;
}

#search:-moz-placeholder {
  /* Firefox 18- */
  color: #fff;
}

#search::-moz-placeholder {
  /* Firefox 19+ */
  color: #fff;
}

#search:-ms-input-placeholder {
  color: #fff;
}

#searchContainer {
  display: flex;
}

#searchContainer .icon-search {
  font-size: 28px;
  padding-left: 15px;
  padding-right: 10px;
}

/* Top right name & logout area */
.logoutAndSearchForm {
  top: 74px;
}

a.logout-text {
  font-weight: bold;
  text-decoration: underline;
}

.lmgrLoginLink {
  float: right;
  color: #1eabe3 !important;
  padding-bottom: 10px;
}

.hello-text {
  color: black;
  font-size: 12px;
  font-weight: bold;
}

.hello-text a {
  font-size: 12px;
  color: black;
}

.logout-pipe {
  color: black;
  margin-left: 0.8rem;
  margin-right: 0.8rem;
}

/* Breadcrumbs */
ul.breadcrumb {
  clear: both;
  background-color: #e5e5e5;
  height: 36px;
  padding-top: 1rem;
  padding-left: 2.5rem;
  padding-bottom: 1rem;

  /* yet another bootstrap override */
  margin-bottom: 0;
}

ul.breadcrumb li,
ul.breadcrumb li a {
  color: black;
  text-transform: capitalize;
  padding-left: 0;
  padding-right: 0;
  font-size: 12px;
  text-decoration: none;
}

ul.breadcrumb li.active {
  font-weight: bold;
  color: black;
  padding-left: 4px;
}

ul.breadcrumb > li + li:before {
  color: black;
  margin-left: 4px;
  margin-right: -4px;
}

ul.breadcrumb > li + li.active:before {
  font-weight: normal;
  margin-right: -5px;
  margin-left: -1px;
}

/* Breadcrumbs New - override the existing css when necessary
        then move these into the breadcrumb css above */
ul.breadcrumb-new {
  clear: both;
  background-color: white;
  height: 36px;
  padding-top: 1rem;
  padding-left: 2.5rem;
  padding-bottom: 1rem;

  /* yet another bootstrap override */
  margin-bottom: 0;
}

ul.breadcrumb-new li,
ul.breadcrumb-new li a {
  color: black;
  text-transform: capitalize;
  padding-left: 0;
  padding-right: 0;
  font-size: 12px;
  text-decoration: none;
}

ul.breadcrumb-new li a {
  text-decoration: underline;
  color: #1eabe3;
}

ul.breadcrumb-new li.active {
  font-weight: normal;
  color: black;
  padding-left: 4px;
}

ul.breadcrumb-new > li + li:before {
  color: black;
  margin-left: 4px;
  margin-right: -4px;
}

ul.breadcrumb-new > li + li.active:before {
  font-weight: normal;
  margin-right: -5px;
  margin-left: -1px;
  content: ' \\003E' !important;
}

/**** Header used on all pages ****/
.assignmentsHeader {
  border-bottom: 2px solid black;
  padding-bottom: 1rem;
}

div.users .assignmentsHeader h2 {
  padding-left: 2rem;
}

#header .chromeWarning {
  border: 2px solid #ffb600;
  color: #ffb600;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
}

#header .chromeWarning .title {
  font-weight: bold;
  font-size: 24px;
}

#header .chromeWarning .body {
  padding-top: 0.5rem;
  font-size: 12px;
  color: black;
}

.capitalized {
  text-transform: capitalize;
}

.header-banner-logo {
  width: 12em;
  max-height: 7em;
  object-fit: contain;
  height: 100%;
}

.header-items-layout {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: 15px;
  margin-top: 15px;
  margin-left: 15px;
  border-bottom: 1px solid #b7b7b7;
}

.header-menu-container {
  flex-grow: 0;
  flex-shrink: 1;
  align-self: flex-end;
}

.header-logo-container {
  flex-grow: 0;
  flex-wrap: nowrap;
  align-self: flex-end;
  margin-bottom: 10px;
}

.header-catalog-header-container {
  flex: 1;
  flex-wrap: inherit;
  align-self: flex-end;
}

#logout-link {
  flex: 0;
  flex-wrap: inherit;
  align-self: flex-end;
  margin-left: auto;
  margin-right: 10px;
  margin-bottom: 5px;
}

#logout-link > a {
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/header.css"],"names":[],"mappings":"AAAA;;;;CAIC;AACD,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,wFAAwF;AACxF;EACE,yDAAkF;EAClF,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,yDAAkF;EAClF,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,kCAAkC;EAClC,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;;EAEpB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;uDACuD;AACvD;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;;EAEpB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* We're gonna be ripping out these pieces that are tied to bootstrap clases.\n.row.header {\n    margin-top: 15px;\n}\n*/\n/* Replacing it with an id */\n#header {\n  margin-top: 15px;\n}\n\n#header .navbar-brand {\n  height: inherit;\n  padding: 0px;\n}\n\n/* Ensure we don't override the logo from custom css, as style below is more specific. */\n#logo {\n  background-image: url('../../assets/images/BAI_HorizontalLockup_Primary_CMYK.svg');\n  background-position: left center;\n  background-repeat: no-repeat;\n}\n\n#BAIOnlylogo {\n  background-image: url('../../assets/images/BAI_HorizontalLockup_Primary_CMYK.svg');\n  background-position: left center;\n  background-repeat: no-repeat;\n  min-height: 88px;\n  margin: 0px 0px 15px;\n  padding: 0px;\n  text-indent: -99999px;\n  background-size: contain;\n  min-width: 75%;\n  float: left;\n}\n\n#header #logo {\n  min-height: 88px;\n  margin: 0px 0px 15px;\n  padding: 0px;\n  text-indent: -99999px;\n  text-indent: -99999px;\n  background-size: contain;\n  min-width: 75%;\n  float: left;\n}\n\n.row.header > .col-md-3 .logout {\n  text-align: right;\n  position: relative;\n}\n\n.row.header > .col-md-3 .logout a {\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.row.header > .col-md-12 .secondaryNav {\n  list-style: none;\n  margin: 0 auto 15px;\n  overflow: hidden;\n  padding: 0px;\n  /* width: 50%; */\n  display: flex;\n}\n\n.row.header > .col-md-12 .secondaryNav li {\n  display: inline;\n  float: right;\n  text-align: center;\n  width: 33%;\n}\n\n/* Search box */\n#search {\n  background-color: white !important;\n  border: gray 1px solid;\n  color: black;\n  border-radius: initial;\n  align-self: center;\n}\n\nform.searchForm {\n  margin-right: -7px;\n  padding-right: 0;\n  padding-top: 5px;\n}\n\n#search::-webkit-input-placeholder {\n  color: #a0a0a0;\n}\n\n#search:-moz-placeholder {\n  /* Firefox 18- */\n  color: #fff;\n}\n\n#search::-moz-placeholder {\n  /* Firefox 19+ */\n  color: #fff;\n}\n\n#search:-ms-input-placeholder {\n  color: #fff;\n}\n\n#searchContainer {\n  display: flex;\n}\n\n#searchContainer .icon-search {\n  font-size: 28px;\n  padding-left: 15px;\n  padding-right: 10px;\n}\n\n/* Top right name & logout area */\n.logoutAndSearchForm {\n  top: 74px;\n}\n\na.logout-text {\n  font-weight: bold;\n  text-decoration: underline;\n}\n\n.lmgrLoginLink {\n  float: right;\n  color: #1eabe3 !important;\n  padding-bottom: 10px;\n}\n\n.hello-text {\n  color: black;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.hello-text a {\n  font-size: 12px;\n  color: black;\n}\n\n.logout-pipe {\n  color: black;\n  margin-left: 0.8rem;\n  margin-right: 0.8rem;\n}\n\n/* Breadcrumbs */\nul.breadcrumb {\n  clear: both;\n  background-color: #e5e5e5;\n  height: 36px;\n  padding-top: 1rem;\n  padding-left: 2.5rem;\n  padding-bottom: 1rem;\n\n  /* yet another bootstrap override */\n  margin-bottom: 0;\n}\n\nul.breadcrumb li,\nul.breadcrumb li a {\n  color: black;\n  text-transform: capitalize;\n  padding-left: 0;\n  padding-right: 0;\n  font-size: 12px;\n  text-decoration: none;\n}\n\nul.breadcrumb li.active {\n  font-weight: bold;\n  color: black;\n  padding-left: 4px;\n}\n\nul.breadcrumb > li + li:before {\n  color: black;\n  margin-left: 4px;\n  margin-right: -4px;\n}\n\nul.breadcrumb > li + li.active:before {\n  font-weight: normal;\n  margin-right: -5px;\n  margin-left: -1px;\n}\n\n/* Breadcrumbs New - override the existing css when necessary\n        then move these into the breadcrumb css above */\nul.breadcrumb-new {\n  clear: both;\n  background-color: white;\n  height: 36px;\n  padding-top: 1rem;\n  padding-left: 2.5rem;\n  padding-bottom: 1rem;\n\n  /* yet another bootstrap override */\n  margin-bottom: 0;\n}\n\nul.breadcrumb-new li,\nul.breadcrumb-new li a {\n  color: black;\n  text-transform: capitalize;\n  padding-left: 0;\n  padding-right: 0;\n  font-size: 12px;\n  text-decoration: none;\n}\n\nul.breadcrumb-new li a {\n  text-decoration: underline;\n  color: #1eabe3;\n}\n\nul.breadcrumb-new li.active {\n  font-weight: normal;\n  color: black;\n  padding-left: 4px;\n}\n\nul.breadcrumb-new > li + li:before {\n  color: black;\n  margin-left: 4px;\n  margin-right: -4px;\n}\n\nul.breadcrumb-new > li + li.active:before {\n  font-weight: normal;\n  margin-right: -5px;\n  margin-left: -1px;\n  content: ' \\003E' !important;\n}\n\n/**** Header used on all pages ****/\n.assignmentsHeader {\n  border-bottom: 2px solid black;\n  padding-bottom: 1rem;\n}\n\ndiv.users .assignmentsHeader h2 {\n  padding-left: 2rem;\n}\n\n#header .chromeWarning {\n  border: 2px solid #ffb600;\n  color: #ffb600;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n#header .chromeWarning .title {\n  font-weight: bold;\n  font-size: 24px;\n}\n\n#header .chromeWarning .body {\n  padding-top: 0.5rem;\n  font-size: 12px;\n  color: black;\n}\n\n.capitalized {\n  text-transform: capitalize;\n}\n\n.header-banner-logo {\n  width: 12em;\n  max-height: 7em;\n  object-fit: contain;\n  height: 100%;\n}\n\n.header-items-layout {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  margin-bottom: 15px;\n  margin-top: 15px;\n  margin-left: 15px;\n  border-bottom: 1px solid #b7b7b7;\n}\n\n.header-menu-container {\n  flex-grow: 0;\n  flex-shrink: 1;\n  align-self: flex-end;\n}\n\n.header-logo-container {\n  flex-grow: 0;\n  flex-wrap: nowrap;\n  align-self: flex-end;\n  margin-bottom: 10px;\n}\n\n.header-catalog-header-container {\n  flex: 1;\n  flex-wrap: inherit;\n  align-self: flex-end;\n}\n\n#logout-link {\n  flex: 0;\n  flex-wrap: inherit;\n  align-self: flex-end;\n  margin-left: auto;\n  margin-right: 10px;\n  margin-bottom: 5px;\n}\n\n#logout-link > a {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
